module.exports = __webpack_public_path__ + "media/damages/car-fr@2x-c8bd8e15.png";